/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 15.11.12, 10:11
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */
import {AbstractTextContentVO, HTMLTextVO} from "@goodgamestudios/localization";
import {TextValide} from "../../stringhelper/TextValide";
import {FontConfigVO} from "../FontConfigVO";
import {ITextFieldStrategy} from "./ITextFieldStrategy";
import {IInternalGGSTextField} from "./IInternalGGSTextField";
import {KeyboardEvent, TextFieldType, TextFieldAutoSize} from "@goodgamestudios/createjs-utilities";
import {IBasicGGSTextField} from "./IBasicGGSTextField";
import {HTMLLinkClickSignal} from "./signals/HTMLLinkClickSignal";

import {GGSCountryController} from "../../language/countryMapper/GGSCountryController";
import {GGSTextAlign} from "./constants/GGSTextAlign";

import Event = createjs.Event;
import FocusEvent = createjs.FocusEvent;
import MouseEvent = createjs.MouseEvent;
import TextEvent = createjs.TextEvent;
import Rectangle = createjs.Rectangle;
import {getLogger} from "@goodgamestudios/logger";
import {TEXT_FIELDS_LOGGER} from "../../../../index";

const logger = getLogger(TEXT_FIELDS_LOGGER + ".GGSTextFieldDefaultStrategy");

export class GGSTextFieldDefaultStrategy implements ITextFieldStrategy {
    public static NAME: string = "GGSTextFieldDefaultStrategy";
    protected _textField: IInternalGGSTextField;
    protected _currentFontConfig: FontConfigVO;
    protected _textFieldText: string;
    protected _originalPosY: number;
    protected _originalHeight: number;
    protected _originalTextHeight: number;
    protected _textLineMetrics: {
        readonly lines: string[];
        readonly lineHeight: number;
        readonly vOffset: number;
        readonly width: number;
        readonly height: number;
    };

     constructor(textField: IInternalGGSTextField) {
        this._textField = textField;
        this._currentFontConfig = this._textField.originalFontConfig;
        this._textFieldText = this._textField.originalTextField.text;
        this._originalPosY = this._textField.originalTextField.y;
        this._originalHeight = this._textField.originalTextField.height;
        this._originalTextHeight = this._textField.originalTextField.textHeight;
        this._textLineMetrics = textField.originalTextField.getMetrics();
    }

    private deactivateInputFieldBehaviour(): void {
        //			trace(NAME + ", deactivateInputFieldBehaviour");

        this._textField.originalTextField.removeEventListener(KeyboardEvent.KEY_DOWN, this.bindFunction(this.onKeyDownEvent));
        this._textField.originalTextField.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.onFocusOutEvent));
        this._textField.originalTextField.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onFocusInEvent));
        this._textField.originalTextField.removeEventListener(Event.CHANGE, this.bindFunction(this.onChangeEvent));
    }

    private activateInputFieldBehaviour(): void {
        //			trace(NAME + ", activateInputFieldBehaviour");

        this._textField.originalTextField.addEventListener(KeyboardEvent.KEY_DOWN, this.bindFunction(this.onKeyDownEvent));
        this._textField.originalTextField.addEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.onFocusOutEvent));
        this._textField.originalTextField.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onFocusInEvent));
        this._textField.originalTextField.addEventListener(Event.CHANGE, this.bindFunction(this.onChangeEvent));
    }

    private onKeyDownEvent(event: KeyboardEvent): void {
        event.stopPropagation();
        this._textField.keyDown.dispatchTyped(event);
    }

    private onKeyUpEvent(event: KeyboardEvent): void {
        event.stopPropagation();
        this._textField.keyUp.dispatchTyped(event);
    }

    private onMouseOutEvent(event: MouseEvent): void {
        this._textField.mouseOut.dispatchTyped((<IBasicGGSTextField>this._textField));
    }

    private onMouseOverEvent(event: MouseEvent): void {
        this._textField.mouseOver.dispatchTyped((<IBasicGGSTextField>this._textField));
    }

    private onChangeEvent(event: Event): void {
        this._textField.model.text = this._textField.originalTextField.text;
        this._textField.change.dispatchTyped(event);
    }

    private onRemovedFromStageEvent(event: Event): void {
        this._textField.removedFromStage.dispatchTyped(event);
    }

    private onScrollEvent(event: Event): void {
        this._textField.scroll.dispatchTyped(event as MouseEvent);
    }

    private onFocusInEvent(event: FocusEvent): void {
        this._textField.focusIn.dispatchTyped((<IBasicGGSTextField>this._textField));
    }

    private onFocusOutEvent(event: FocusEvent): void {
        this._textField.focusOut.dispatchTyped((<IBasicGGSTextField>this._textField));
    }

    private onClickEvent(event: MouseEvent): void {
        this._textField.click.dispatchTyped((<IBasicGGSTextField>this._textField));
    }

    private onTextEventLinkEvent (event: TextEvent): void {
        this._textField.htmlLinkClick.dispatchTyped((<IBasicGGSTextField>this._textField), event.text);
    }

    public displayText(textContent: string, textContentVO: AbstractTextContentVO = null): void {
        if (textContentVO && textContentVO instanceof HTMLTextVO) {
            // this._textField.originalTextField.styleSheet = this.composeStyleSheet(((<HTMLTextVO>textContentVO)).linkFormats);
            this._textField.originalTextField.htmlText = textContent;
        } else {
            this._textField.originalTextField.text = textContent;
        }

        // this._textField.model.updateTextDimensionDependentProperties();

        //			trace(NAME + ", displayText() -> " + textContent);
    }

    // private composeStyleSheet(vo: HTMLLinkFormatsVO): StyleSheet {
    //     let style: StyleSheet = new StyleSheet();
    //
    //     if (vo) {
    //         let hover: any = {};
    //         hover.textDecoration = vo.linkHoverFormat.textDecoration;
    //         hover.color = "#" + Number(vo.linkHoverFormat.color).toString(16);
    //
    //         let active: any = {};
    //         active.textDecoration = vo.linkActiveFormat.textDecoration;
    //         active.color = "#" + Number(vo.linkActiveFormat.color).toString(16);
    //
    //         let link: any = {};
    //         link.textDecoration = vo.linkNormalFormat.textDecoration;
    //         link.color = "#" + Number(vo.linkNormalFormat.color).toString(16);
    //
    //         style.setStyle("a:hover", hover);
    //         style.setStyle("a:active", active);
    //         style.setStyle("a:link", link);
    //     }
    //
    //     let p: any = {};
    //     p.color = "#" + Number(this._textField.model.color).toString(16);
    //     p.fontSize = this._textField.model.size;
    //     p.fontFamily = this._currentFontConfig.fontName;
    //     p.textAlign = this._textField.model.textAlign;
    //
    //     style.setStyle("p", p);
    //
    //     return style;
    // }

    public applyFontConfiguration(config: FontConfigVO): void {
        this.currentFontConfig = config;

        this.updateTextFormat();
    }

    public activate(): void {
        if (GGSCountryController.instance.currentCountry.isLanguageWrittenRightToLeft) {
            // If the GoodgameTextField.DETECT_SUITABLE_STRATEGY option is activated, the TextField is able
            // to detect the needed strategy to display it's content. In that case it's possible that the app
            // language is e.g. arabic but the current GGSTextField should only contain european arabic numbers or
            // a text with only latin characters. Therefore even in this strategy the textAlign property has to be
            // adjusted to right if a RTL language is active.
            this._textField.model.textAlign = (this._textField.model.textAlignOriginal !== GGSTextAlign.LEFT) ? this._textField.model.textAlignOriginal : GGSTextAlign.RIGHT;
        } else {
            this._textField.model.textAlign = this._textField.model.textAlignOriginal;
        }

        // Update listeners
        for (let eventType of this._textField.model.registeredEventListeners) {
            this.addEventListenerForEventType(eventType);
        }

        this._textField.originalTextField.visible = true;
        //			// Update properties
        //			_textField.model.updateAllProperties();
    }

    public deactivate(): void {
        this._textField.originalTextField.visible = false;

        // Deactivate listeners
        for (let eventType of this._textField.model.registeredEventListeners) {
            this.removeEventListenerForEventType(eventType);
        }
    }

    public setFocus(): void {
        // TODO: @HTML5: set focus on input text field.
        //console.warn("TODO: @HTML5: GGSTextFieldDefaultStrategy.setFocus")
        // this._textField.originalTextField.stage.focus = this._textField.originalTextField;
    }

    public updateTabIndex(index: number): void {
        this._textField.originalTextField.tabIndex = index;
    }

    public updateTabEnabled(flag: boolean): void {
        this._textField.originalTextField.tabEnabled = flag;
    }

    public updateMaxChars(value: number): void {
        this._textField.originalTextField.maxChars = value;
    }

    public updateX(value: number): void {
        this._textField.originalTextField.x = value;
    }

    public updateY(value: number): void {
        this._textField.originalTextField.y = value;
    }

    public updateWidth(value: number): void {
        this._textField.originalTextField.width = value;
    }

    public updateHeight(value: number): void {
        this._textField.originalTextField.height = value;
    }

    public updateScaleX(value: number): void {
        this._textField.originalTextField.scaleX = value;
    }

    public updateScaleY(value: number): void {
        this._textField.originalTextField.scaleY = value;
    }

    public updateScrollV(value: number): void {
        this._textField.originalTextField.scrollV = value;
    }

    public updateRotation(value: number): void {
        this._textField.originalTextField.rotation = value;
    }

    public updateBackground(value: boolean): void {
        this._textField.originalTextField.background = value;
    }

    public updateBackgroundColor(value: string): void {
         this._textField.originalTextField.backgroundColor = value;
    }

    public get maxScrollV(): number {
        return this._textField.originalTextField.maxScrollV;
    }

    public get scrollV(): number {
        return this._textField.originalTextField.scrollV;
    }

    public updateIndent(value: number): void {

        /*if (this._textField.originalTextField.styleSheet) {
         debug("Indent not applicable due TextField has a Stylesheet.");
         return;
         }*/

        let format = this._textField.originalTextField.defaultTextFormat;
        format.indent = value;
        this._textField.originalTextField.defaultTextFormat = format;
        this._textField.originalTextField.setTextFormat(format);
    }

    public get currentFontConfig(): FontConfigVO {
        return this._currentFontConfig;
    }

    public set currentFontConfig(config: FontConfigVO) {

        // TODO  HTML5 HTML-2128  i could not understand why we need a TextFieldModel and why code below does what it does.
        // Copy changeable properties if there is a config already defined
        // color
        // if (this._textField.model.color) {
        //     this._currentFontConfig.textFormat.color = this._textField.model.color;
        // }
        // else {
        //     this._textField.model.color = config.textFormat.color as string;
        // }
        //
        // // fontSize
        // if (this._textField.model.size) {
        //     this._currentFontConfig.textFormat.size = this._textField.model.size;
        // }
        // else {
        //     this._textField.model.size = config.textFormat.size;
        // }

        this._currentFontConfig = config;
    }

    public dispose(): void {
        // Remove listeners
        this._textField.originalTextField.removeEventListener("click", this.bindFunction(this.onClickEvent));
        this._textField.originalTextField.removeEventListener("mouseover", this.bindFunction(this.onMouseOverEvent));
        this._textField.originalTextField.removeEventListener("mouseout", this.bindFunction(this.onMouseOutEvent));
        this._textField.originalTextField.removeEventListener(KeyboardEvent.KEY_DOWN, this.bindFunction(this.onKeyDownEvent));
        this._textField.originalTextField.removeEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onKeyUpEvent));
        this._textField.originalTextField.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.onFocusOutEvent));
        this._textField.originalTextField.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onFocusInEvent));
        this._textField.originalTextField.removeEventListener(Event.CHANGE, this.bindFunction(this.onChangeEvent));
        this._textField.originalTextField.removeEventListener(TextEvent.LINK, this.bindFunction(this.onTextEventLinkEvent));
        this._textField.originalTextField.removeEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.onRemovedFromStageEvent));

        // Null references
        this._textField = null;
        this._currentFontConfig = null;
    }

    public updateDisplayAsPassword(value: boolean): void {
        this._textField.originalTextField.displayAsPassword = value;
    }

    /**
     * Indicates if the input TextField displays still the default text content.
     *
     * @return
     */
    public get containsDefaultTextContent(): boolean {
        let inputText: string = this._textField.text;

        // Exception for password fields: Trim whitespaces first!
        if (this._textField.originalTextField.displayAsPassword) {
            inputText = TextValide.trimPassword(this._textField.text);
        }

        if (inputText === this._textField.model.textDefault) {
            return true;
        }

        return false;
    }

    public updateMultiline(value: boolean): void {
        this._textField.originalTextField.multiline = value;
    }

    public updateWordwrap(value: boolean): void {
        this._textField.originalTextField.wordWrap = value;
    }

    public updateRestrict(value: string): void {
        this._textField.originalTextField.restrict = value;
    }

    public get textWidth(): number {
        return this._textField.originalTextField.textWidth;
    }

    public get textHeight(): number {
        return this._textField.originalTextField.textHeight;
    }

    public addEventListenerForEventType(type: string): void {
        //			trace(NAME + ", addEventListenerForEventType() -> type: " + type);

        switch (type) {
            case MouseEvent.CLICK:

                this._textField.originalTextField.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickEvent));
                break;

            case FocusEvent.FOCUS_IN:

                this._textField.originalTextField.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onFocusInEvent));
                break;

            case FocusEvent.FOCUS_OUT:

                this._textField.originalTextField.addEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.onFocusOutEvent));
                break;

            case KeyboardEvent.KEY_DOWN:

                this._textField.originalTextField.addEventListener(KeyboardEvent.KEY_DOWN, this.bindFunction(this.onKeyDownEvent));
                break;

            case KeyboardEvent.KEY_UP:

                this._textField.originalTextField.addEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onKeyUpEvent));
                break;

            case MouseEvent.MOUSE_OVER:

                this._textField.originalTextField.addEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOverEvent));
                break;

            case MouseEvent.MOUSE_OUT:

                this._textField.originalTextField.addEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOutEvent));
                break;

            case HTMLLinkClickSignal.HTML_LINK_CLICK:
                this._textField.originalTextField.addEventListener(TextEvent.LINK, this.bindFunction(this.onTextEventLinkEvent));
                break;

            case Event.CHANGE:

                this._textField.originalTextField.addEventListener(Event.CHANGE, this.bindFunction(this.onChangeEvent));
                break;

            case Event.REMOVED_FROM_STAGE:

                this._textField.originalTextField.addEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.onRemovedFromStageEvent));
                break;

            case MouseEvent.MOUSE_WHEEL: // for ScrollSignal, see ScrollSginal.mappedEventType

                this._textField.originalTextField.addEventListener(MouseEvent.MOUSE_WHEEL, this.bindFunction(this.onScrollEvent));
                break;

            default:

                logger.warn("Not supported event type: " + type);
        }
    }

    public removeEventListenerForEventType(type: string): void {
        //			trace(NAME + ", removeEventListenerForEventType() -> type: " + type);

        switch (type) {
            case MouseEvent.CLICK:

                this._textField.originalTextField.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickEvent));
                break;

            case FocusEvent.FOCUS_IN:

                this._textField.originalTextField.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onFocusInEvent));
                break;

            case FocusEvent.FOCUS_OUT:

                this._textField.originalTextField.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.onFocusOutEvent));
                break;

            case KeyboardEvent.KEY_DOWN:

                this._textField.originalTextField.removeEventListener(KeyboardEvent.KEY_DOWN, this.bindFunction(this.onKeyDownEvent));
                break;

            case KeyboardEvent.KEY_UP:

                this._textField.originalTextField.removeEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onKeyUpEvent));
                break;

            case MouseEvent.MOUSE_OVER:

                this._textField.originalTextField.removeEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOverEvent));
                break;

            case MouseEvent.MOUSE_OUT:

                this._textField.originalTextField.removeEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOutEvent));
                break;

            case HTMLLinkClickSignal.HTML_LINK_CLICK:

                this._textField.originalTextField.removeEventListener(TextEvent.LINK, this.bindFunction(this.onTextEventLinkEvent));
                break;

            case Event.CHANGE:

                this._textField.originalTextField.removeEventListener(Event.CHANGE, this.bindFunction(this.onChangeEvent));
                break;

            case Event.REMOVED_FROM_STAGE:

                this._textField.originalTextField.removeEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.onRemovedFromStageEvent));
                break;

            case MouseEvent.MOUSE_WHEEL: // for ScrollSignal, see ScrollSginal.mappedEventType

                this._textField.originalTextField.removeEventListener(MouseEvent.MOUSE_WHEEL, this.bindFunction(this.onScrollEvent));
                break;

            default:

                logger.warn("Not supported event type.");
        }
    }

    public hasEventListenerForEventType(type: string): boolean {
        //			trace(NAME + ", hasEventListenerForEventType() -> type: " + type);
        return this._textField.originalTextField.hasEventListener(type);
    }

    public get caretIndex(): number {
        return this._textField.originalTextField.caretIndex;
    }

    public updateMouseEnabled(value: boolean): void {
        this._textField.originalTextField.mouseEnabled = value;
    }

    /**
     * Replaces old TextFieldHelper methods.
     * Use:
     * verticalAlign = GGSVerticalAlign.MIDDLE -> instead of -> TextFieldHelper.changeVerticalAlignInMultiLineTextfield(textfield);
     *
     * @param direction
     */
    public updateVerticalAlign(direction: string): void {
           this._textField.originalTextField.verticalAlign = direction;
        // TODO @HTML5  HTML-2128 check textBaseline The vertical alignment point on the font. Any of "top", "hanging", "middle", "alphabetic", "ideographic", or "bottom".   from Text EaselJS
        // switch (direction) {
        //     case GGSVerticalAlign.MIDDLE:
        //
        //         this._textField.originalTextField.textBaseline = GGSVerticalAlign.MIDDLE;
        //         //
        //         // //Offset on the y Axis to move the TextField. DO NOT CALCULATE WITH _textfield.originalTextField.textheight!!!!!!!!!!!!
        //         // //the height from the textLineMetrics is only the height of 1 line, therefore we multiply it by the number of lines.
        //         // let yOffset: number = (this._originalHeight - (this._textLineMetrics.height * this._textField.originalTextField.numLines)) * .5;
        //         // // the new Y Position of the textField After it has been aligned
        //         // let newPosY: number = this._originalPosY + yOffset;
        //         // // set the original textField Y position to new Y Position
        //         // this._textField.originalTextField.y = newPosY;
        //         //
        //         // // this._textField.originalTextField.autoSize = TextFieldAutoSize.CENTER;
        //         break;
        //
        //     case GGSVerticalAlign.TOP:
        //         this._textField.originalTextField.textBaseline = GGSVerticalAlign.TOP;
        //         // TODO: Implement
        //         break;
        //
        //     default:
        //         debug("Invalid or not supported vertical align direction used:" + direction);
        // }
    }

    public updateTextAlign(direction: string): void {
        this._currentFontConfig.textFormat.align = direction;

        this.updateTextFormat();
    }

    public setSelection(beginIndex: number, endIndex: number): void {
        this._textField.originalTextField.setSelection(beginIndex, endIndex);
    }

    public updateSelectable(value: boolean): void {
        this._textField.originalTextField.selectable = value;
    }

    public updateType(type: string): void {

        if (type === TextFieldType.INPUT) {
            this._textField.originalTextField.type = type;
            this.activateInputFieldBehaviour();
        } else if (type === TextFieldType.DYNAMIC) {
            this._textField.originalTextField.type = type;
            this.deactivateInputFieldBehaviour();
        } else {
            logger.warn("Unsupported type: " + type);
        }
    }

    public updateSize(value: any): void {
        this._currentFontConfig.textFormat.size = value;

        this.updateTextFormat();
    }

    public updateColor(color: string | number): void {
        this._currentFontConfig.textFormat.color = color;

        this.updateTextFormat();
    }

    private updateTextFormat(): void {
        this._textField.originalTextField.setTextFormat(this._currentFontConfig.textFormat);
    }

    public updateVisible(value: boolean): void {
        this._textField.originalTextField.visible = value;
    }

    public set autoSize(value: TextFieldAutoSize) {
        this._textField.originalTextField.autoSize = value;
    }

    /**
     * sets the fontsize of a textfield based on volume of the textWidth/textHeight and width/height (or an optional bounding rectangle)
     * @param bounds optional target rectangle "dot dot dot" only width and height taken into account
     */

    public fitTextSizeToBounds(bounds: Rectangle = null): void {
        //logger.warn("fitTextSizeToBounds:: TEMPORARY COMMENTED OUT "); // TODO @HTML5 HTML-2128
        /*
        if (!bounds) {
            bounds = new Rectangle(0, 0, this._textField.model.width, this._textField.model.height)
        }

        let guesses: number = 0;

        // if no content, no scale
        if (this.textWidth == 0 || this.textHeight == 0 || this._textField.text == "") {
            return;
        }

        // check, if textfield.numLines == 1... if so, assume smaller target bounds
        if (this._textField.numLines <= 1) {
            bounds.height = this._textField.size + 2;
        }

        // step 1: get the ratio of the wanted rectangle to the actual text

        let sourceVolume: number = this.textWidth * this.textHeight;
        let targetVolume: number = bounds.width * bounds.height;

        //trace("source: " + textWidth + "x" + textHeight);
        //trace("target: " + bounds.width + "x" + bounds.height);

        // if already fitting... jump out
        if (targetVolume > sourceVolume) {
            return;
        }

        //trace("original text size: " + _textField.model.size);

        // step 2: use the ratio to get the (guessed) maximum font size posssibly needed
        let sizeMin: number = GoodgameTextFieldManager.getInstance().minimumAutoFitFontSize;
        let sizeMax: number = Math.min(Number(this._textField.model.size), GoodgameTextFieldManager.getInstance().maximumAutoFitFontSize);

        // take the guess into account, if not scaling up... decrease by ratio/4

        //trace("sizeMax: " + sizeMax);
        //trace("volume ratio: " + (targetVolume / sourceVolume));
        //trace("source volume: " + sourceVolume/1000);
        //trace("target volume: " + targetVolume/1000);

        let range: number = sizeMax - sizeMin;
        range = range * (targetVolume / sourceVolume);
        sizeMax = sizeMin + range;

        //trace("possible sizes: " + sizeMin + " to " + sizeMax);

        //			info( "default minimum size: " + GoodgameTextFieldManager.getInstance().minimumAutoFitFontSize );
        //			info( "default max size: " + GoodgameTextFieldManager.getInstance().maximumAutoFitFontSize );
        //
        //			info( "min guessed size: " + sizeMin );
        //			info( "max guessed size: " + sizeMax );
        //
        //			info( "source volume: " + sourceVolume );
        //			info( "destination volume: " + targetVolume );

        // step 3: do a binary search for the right size
        let sizeCur: number;
        let sizeMaxCur: number = sizeMax;
        let isFit: boolean = false;

        if (sizeMin == sizeMax) {
            sizeCur = sizeMin;
        }
        else {
            while (sizeMin != sizeCur) {
                sizeCur = Math.ceil((sizeMin + sizeMaxCur) * .5);
                // apply fontsize
                this.updateSize(sizeCur);
                guesses++;

                // check if fits in bounds, iterate if not
                if (this.textWidth < bounds.width && this.textHeight < bounds.height) {
                    sizeMin = sizeCur;
                }
                else {
                    sizeMaxCur = sizeCur - 1;
                }
            }
        }

        // step 5: check if we can expand a little more
        while (this.textWidth < bounds.width && this.textHeight < bounds.height) {
            this.updateSize(++sizeCur);
            guesses++;
        }

        this._textField.model.size = sizeCur - 1;

        //			info( "guessed fitting size: " + sizeCur );
        //			debug( "used " + guesses + " to fit text" );
        */
    }

    public updateAutoFitToBounds(value: boolean): void {

        if (value) {
            this.fitTextSizeToBounds();
        }
    }

    public set autoFitToBounds(value: boolean) {
        this._textField.model.autoFitToBounds = value;
        this.updateAutoFitToBounds(value);
    }

    public get autoFitToBounds(): boolean {
        return this._textField.model.autoFitToBounds;
    }

    public get numLines(): number {
        return this._textField.originalTextField.numLines;
    }
}
